module.exports = __webpack_public_path__ + "media/svg/original_dark_horizontal-3552ae52.svg";